import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_CAREPROVIDERS_FULFILLED = "FETCH_CAREPROVIDERS_FULFILLED";
export const FETCH_CAREPROVIDERS_REJECTED = "FETCH_CAREPROVIDERS_REJECTED";
export const FETCH_CAREPROVIDERS_PENDING = "FETCH_CAREPROVIDERS_PENDING";
export const RESET = "RESET";

export function careProviders(professionId) {
  const token = localStorage.getItem("accessToken")
  return dispatch => {
    dispatch({
      type: "FETCH_CAREPROVIDERS",
      payload: axios({
        method: "get",
        url: `${API_BASE}/api/v2/second-opinion/care-providers/null/`+professionId,

        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetCareProviders() {
  return (dispatch) => {
      dispatch({
          type: "RESET",
      });
  };
}